module.exports = __webpack_public_path__ + "static/media/one-market-abstract-tall.5cf1bf43.png";